import React, { useEffect, useState, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../UnclaimedDividendHistory/UnclaimedDividendHistory.css";
import { trackEvent, trackPageView } from "../../utils/tracking";
function UnclaimedDividendHistory() {
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/Unclaimed-Redemption-and-IDCW-(Dividend)",
      "jmf_redemption_unclaimed-redemption-and-idcw"
    );
    // trackPageView(
    //   "http://localhost:710/Unclaimed-Redemption-and-IDCW-(Dividend)",
    //   "jmf_redemption_unclaimed-redemption-and-idcw"
    // );
    trackEvent({
      category: "Static Page",
      action: "UnclaimedDividendHistory Page Loaded",
      label: "jmf_redemption_unclaimed-redemption-and-idcw",
      value: 1,
    });
  }, []);

  const [pathname, setPathName] = useState("");
  const iframeRef = useRef(null);
  const [path, setPathnameURL] = useState("");
  useEffect(() => {
    var pathnameurl = window.location.pathname;
    const regEx = new RegExp("-", "g");
    const resultName = pathnameurl.replace(regEx, " ");
    setPathnameURL(resultName);

    document.getElementById("iframeDiv").style.display = "none";
    const pathname = window.location.pathname.replace(
      /([a-z])([A-Z])/g,
      "$1 $2"
    );
    const lastSegment = pathname.slice(pathname.lastIndexOf("/") + 1);
    const CategoryIdUrlid = lastSegment;
    setPathName(CategoryIdUrlid);
  });

  const handleChange = () => {
    document.getElementById("iframeDiv").style.display = "block";

    if (iframeRef.current) {
      iframeRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <section className="navs-and-dividends-section">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="">
                <h2>Unclaimed Redemption & IDCW (Dividend)</h2>
                <p className="p-gray-text">
                  SEBI vide circular no. SEBI/HO/IMD/DF2/CIR/P/2016/37 dated
                  February 25, 2016 has mandated Mutual Funds to provide on
                  their website, the list of names and addresses of Investors in
                  whose folios there are unclaimed amounts (Redemption / IDCW).
                  Further, Mutual Funds are also required to provide information
                  on the process of claiming the unclaimed amount(s) and the
                  necessary forms / documents required for the same.
                </p>

                <ul className="dot-ul">
                  In this context, investors may like to note the following:
                  <li>
                    Redemption / IDCW cheques sent to investors that remain
                    unpaid beyond their validity period are categorised as
                    unclaimed.
                  </li>
                  <li>
                    The investor will be eligible to receive the original amount
                    payable to an investor, together with any income earned
                    thereon by deployment in permitted instruments until three
                    years from the date of the instrument. Any income earned
                    after this date is transferred to the Investor Education and
                    Protection Fund in accordance with the provisions of the
                    above mentioned Circular and the SEBI Regulations /
                    Guidelines
                  </li>
                  <li>
                    Investors/Unit Holders of the schemes of the Mutual Fund can
                    obtain information on the folios with unclaimed amounts from
                    the website of the Mutual Fund as mentioned below as well as
                    from the website of AMFI (www.amfiindia.com).
                  </li>
                  <li>
                    Information on the unclaimed amount and its prevailing value
                    will be separately disclosed to investors through monthly
                    Consolidated Account Statement sent to the investors in case
                    of transacted cases & and on half yearly basis in case of
                    non- transacted cases for respective folios.
                  </li>
                </ul>

                <ul className="no-style-ul">
                  Process to Claim the Unclaimed IDCW/Redemption amounts.
                  <li>
                    Investors wishing to claim such amounts, may fill the
                    Unclaimed Redemption / IDCW claim form{" "}
                    <a onClick={handleChange}>(click here)</a> and comply with
                    the requirements stated therein.
                  </li>
                  <li>
                    Important : To process the claim, bank account details are
                    mandatory. Investors are requested to get the bank account
                    updated in their folio prior submitting the claim request.
                  </li>
                  <li>
                    {/* Request would be processed with the NAV as on the date of receipt of the
                                        request. */}
                    Request would be processed with the applicable NAV as on the
                    date of receipt of the request before the cut off time.
                  </li>
                  <li>
                    TDS as applicable would be deducted on capital gains, if
                    any, earned by the investor, if the investor is an NRI.
                  </li>
                </ul>
                {/* <div className="frame" id="iframeDiv">
                                    <iframe id="ifrKarvy" src="https://mfs.kfintech.com/udh/udh.aspx?fund=105" width="100%" height="100%"></iframe>

                                </div> */}

                <div className="frame" id="iframeDiv" ref={iframeRef}>
                  <iframe
                    id="ifrKarvy"
                    src="https://mfs.kfintech.com/udh/udh.aspx?fund=105"
                    width="100%"
                    height="100%"
                  ></iframe>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default UnclaimedDividendHistory;
